import {
  Box,
  Grid,
  Heading,
  Image,
  ListItem,
  OrderedList,
  Stack,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const Offer = () => {
  return (
    <>
      <Box
        w="100%"
        mt={["-20px", "-20px", "-20px", "-70px"]}
        bg="url('./img/vishal/offers.png')"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        height={["200px", "300px", "450px", "550px", "600px"]}
      >
        <Box w={{ base: "90%", md: "80%", lg: "80%" }} mx="auto" h="100%">
          <Box>
            <Text
              fontSize={{
                base: "25px",
                sm: "35px",
                md: "40px",
                lg: "50px",
                xl: "50px",
              }}
              color={"#081839"}
              textAlign="center"
              pt="50px"
              fontWeight={"700"}
              textTransform={"capitalize"}
            >
              <span
                    style={{
                      fontFamily: "Playfair Display",
                    }}
                  >Find the best deals and join us for the ultimate vacation.</span> 
            </Text>
          </Box>
        </Box>
      </Box>

      <Box w={"90%"} m={"auto"}>
        <Box
          textAlign={"justify"}
          borderBottom={"2px solid #1E1E1E"}
          my="3"
          mb="2"
        >
          <Text
            fontWeight="800"
            fontSize={{ base: "15px", md: "20px", lg: "25px" }}
            color={"#5392F7"}
          >
            Exclusive Promotions & Discounts Onboard The Nauti Amigo
          </Text>
          <Text
            fontWeight="500"
            fontSize={{ base: "10px", md: "17px", lg: "20px" }}
            my={{ base: "10px", md: "20px" }}
          >
            Enjoy exclusive promotions and discounts onboard The Nauti Amigo -
            Asia's only luxury Danaos Tourism cruise. Use the promo code at
            checkout for savings and join us for a luxurious journey at sea!
          </Text>
          {/* <Text
            fontWeight="500"
            fontSize={{ base: "10px", md: "17px", lg: "20px" }}
            my={{ base: "10px", md: "20px" }}
          >
            Simply ‘copy’ the promo code below during checkout and enjoy the
            promotions!
          </Text> */}
        </Box>

        <Grid
          mt="10"
          templateColumns={[
            "repeat(1, 1fr)",
            "repeat(1, 1fr)",
            "repeat(2, 1fr)",
            "repeat(3, 1fr)",
          ]}
          gap={6}
          data-aos="fade-up"
        >
          <Box
            maxW={"445px"}
            w={"full"}
            bg={useColorModeValue("white", "gray.900")}
            boxShadow={"2xl"}
            rounded={"md"}
            p={6}
            overflow={"hidden"}
          >
            <Box
              h={"310px"}
              bg={"gray.100"}
              mt={-6}
              mx={-6}
              mb={6}
              pos={"relative"}
            >
              <Image w={"100%"} h={"100%"} src={"./img/vishal/offer1.png"} />
            </Box>
            <Stack>
              <Text
                color={"green.500"}
                textTransform={"uppercase"}
                fontWeight={800}
                fontSize={"sm"}
                letterSpacing={1.1}
              >
                RAISE YOUR GLASSES
              </Text>
              <Heading
                color={useColorModeValue("gray.700", "white")}
                fontSize={"xl"}
                fontFamily={"body"}
              >
                Promo Code not needed.
                <br />
                Valid till: 1 Feb – 31 March...
              </Heading>
              <Text color={"gray.500"}>
                Complimentary drink from our standard bar. Not applicable on
                special sailings.
              </Text>
            </Stack>
          </Box>

          <Box
            maxW={"445px"}
            w={"full"}
            bg={useColorModeValue("white", "gray.900")}
            boxShadow={"2xl"}
            rounded={"md"}
            p={6}
            overflow={"hidden"}
          >
            <Box
              h={"310px"}
              bg={"gray.100"}
              mt={-6}
              mx={-6}
              mb={6}
              pos={"relative"}
            >
              <Image w={"100%"} h={"100%"} src={"./img/vishal/offer2.png"} />
            </Box>
            <Stack>
              <Text
                color={"green.500"}
                textTransform={"uppercase"}
                fontWeight={800}
                fontSize={"sm"}
                letterSpacing={1.1}
              >
                GREAT GOA SAIL Promo
              </Text>
              <Heading
                color={useColorModeValue("gray.700", "white")}
                fontSize={"xl"}
                fontFamily={"body"}
              >
                Promo Code: TAKEMEHOME
                <br />
                Valid till: June 2023...
              </Heading>
              <Text color={"gray.500"}>
                Free Single-way Limo Ride home worth Rs.7000. Every purchase of
                2x Adult City Lights Dinner...
              </Text>
            </Stack>
          </Box>

          <Box
            maxW={"445px"}
            w={"full"}
            bg={useColorModeValue("white", "gray.900")}
            boxShadow={"2xl"}
            p={6}
            rounded={"md"}
            overflow={"hidden"}
          >
            <Box
              h={"310px"}
              bg={"gray.100"}
              mt={-6}
              mx={-6}
              mb={6}
              pos={"relative"}
            >
              <Image w={"100%"} h={"100%"} src={"./img/vishal/offer3.png"} />
            </Box>
            <Stack>
              <Text
                color={"green.500"}
                textTransform={"uppercase"}
                fontWeight={800}
                fontSize={"sm"}
                letterSpacing={1.1}
              >
                COMPLIMENTARY PROSECCO
              </Text>
              <Heading
                color={useColorModeValue("gray.700", "white")}
                fontSize={"xl"}
                fontFamily={"body"}
              >
                Promo Code: FREEWINE
                <br />
                Valid till: June 2023
              </Heading>
              <Text color={"gray.500"}>
                A complimentary bottle of Prosecco with every purchase. And 2x
                Adult City Lights Dinner...
              </Text>
            </Stack>
          </Box>
        </Grid>

        <Box
          textAlign={"justify"}
          mt="10"
          p={6}
          borderRadius={10}
          border={"1px solid #E3E6E6"}
        >
          <Text
            fontWeight="700"
            fontSize={["12px", "17px", "20px", "20px"]}
            my={{ base: "5px", md: "5px" }}
            color={"#5392F7"}
          >
            Terms & Conditions:
          </Text>
          <OrderedList
            fontSize={["10px", "15px", "15px", "18px"]}
            fontWeight="500"
          >
            <ListItem>
              Promo code requires the purchase of 2 regular-priced City Lights
              dinner cruise tickets (INR 225++) on danaostourism.com, enter
              promotion code “FREEWINE” at checkout.
            </ListItem>
            <ListItem>
              Promo code has no monetary value, single-use only and cannot be
              transferred, exchanged for cash, or offset for any other products
              or services.
            </ListItem>
            <ListItem>
              Danaos Tourism Ship reserves the right to change these terms and
              conditions at any time without prior notice.
            </ListItem>
            <ListItem>
              This promo code cannot be used in conjunction with any other
              ongoing promotions.
            </ListItem>
          </OrderedList>
        </Box>
      </Box>
    </>
  );
};

export default Offer;
